module.exports = __webpack_public_path__ + "img/nongMin6.2dda88f4.png";